import { createSelector } from 'reselect';
import { professionRewardsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const professionJobsYearsSelector = createSelector([professionRewardsSelector], (professionRewards) =>
  extractDatesFromNestedItems(
    [professionRewards.content],
    [
      {
        type: 'date',
        field: 'date',
      },
    ],
  ),
);
